import React, { useEffect, useState } from "react";
import Header from "../../../component/organisms/header";
import MainLayout from "../../../component/atoms/layout/mainLayout";
import Sidebar from "../../../component/organisms/sidebar";
import DetailPageLayout from "../../../component/atoms/layout/detail/detailPageLayout";
import TableTitle from "./../../../component/atoms/text/table/tableTitle";
import { route } from "./../../../router/route";
import moment from "moment";
import { errorHandler } from "../../../util/errorHandler";
import RedBtn from "../../../component/atoms/button/redBtn";
import Modal from "../../../component/templates/Modal";
import { toast } from "react-toastify";
import { toastMsg } from "../../../util/toastMsg";
import PopupOverLay from "../../../component/templates/PopupOverlay";
import Popup from "../../../component/molecules/popup";
import PretendardText from "../../../component/atoms/text/pretendardText";
import SubSideBar from "../../../component/organisms/subSideBar";
import SubSideBarItem from "../../../component/molecules/subSideBarItem";
import { useNavigate } from "react-router-dom";
import scrollToTop from "../../../util/scrollToTop";
import DividedBtn from "../../../component/atoms/button/dividedBtn";
import BasicBtn from "./../../../component/atoms/button/basicBtn";
import ImgInputLarge from "../../../component/atoms/input/imgInputLarge";
import ImgPreviewLarge from "../../../component/molecules/imgPreviewLarge";
import { useRecoilState } from "recoil";
import {
  productIsUploadState,
  productManagementState,
} from "../../../store/productState";
import ProductApi from "../../../api/product.api";
import { fileUrl } from "../../../api/api";
import FileApi from "../../../api/file.api";

// TODO:
// - 추후 미리보기 페이지 구현 필요 (프리뷰 페이지 별도로 만들어야 할듯)

const ShoppingProductCreateImage = () => {
  const navigate = useNavigate();

  // ---------- 마운트가 되면 ---------- //
  useEffect(() => {
    // 편집 권한 체크
    const writeMenu = sessionStorage.getItem("writeMenu");

    if (!writeMenu?.includes(route.shopping_product)) {
      navigate(-1);
      toast(
        <>
          편집 권한이 없습니다.
          <br />
          최고관리자에게 문의하세요.
        </>
      );
      return;
    }

    getStorageList();

    // url 직접 입력으로 들어온 경우 기본 내용 설정 페이지로 이동
    if (!productManagementValue.id) {
      navigate(route.shopping_product_create_basic);
      setProductIsUpload(true);
    } else {
      setProductIsUpload(false);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ---------- 페이지 타이틀 관련 ---------- //
  const pageTitleList = [
    "01. 기본 내용 설정",
    "02. 상세 내용 설정",
    "03. 목차/커리큘럼 설정",
    "04. 썸네일 및 배너 설정",
    "05. 기타 설정",
  ];

  // ---------- 상품 업로드 상태 관련 ---------- //
  const [, setProductIsUpload] = useRecoilState(productIsUploadState);

  // ---------- 상품 추가 입력값 관련 ---------- //
  const [productManagementValue, setProductManagementValue] = useRecoilState(
    productManagementState
  );

  // ---------- 썸네일 및 배너 설정 ---------- //
  // 이미지 추가, 삭제
  const [imageObj, setImageObj] = useState({
    thumbnailFile: null,
    thumbnailFileUrl: null,
    thumbnailFileName: productManagementValue.thumbnailOriginFileName,
    bannerFile: null,
    bannerFileUrl: null,
    bannerFileName: productManagementValue.bannerOriginFileName,
  });

  const inputFile = (e, type) => {
    const file = e.target.files[0];

    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    if (type === "thumbnail") {
      fileReader.onload = (value) => {
        setImageObj({
          ...imageObj,
          thumbnailFile: file,
          thumbnailFileUrl: value.target.result,
          thumbnailFileName: file.name,
        });
      };
    }

    if (type === "banner") {
      fileReader.onload = (value) => {
        setImageObj({
          ...imageObj,
          bannerFile: file,
          bannerFileUrl: value.target.result,
          bannerFileName: file.name,
        });
      };
    }
    e.target.value = "";
  };

  const deleteFile = (type) => {
    if (type === "thumbnail") {
      setImageObj({
        ...imageObj,
        thumbnailFile: null,
        thumbnailFileUrl: null,
        thumbnailFileName: null,
      });
    } else if (type === "banner") {
      setImageObj({
        ...imageObj,
        bannerFile: null,
        bannerFileUrl: null,
        bannerFileName: null,
      });
    }
  };

  // ---------- 전체 영역 팝업 상태 관련 ---------- //
  const [popupOpen, setPopupOpen] = useState({
    temporary: false, // 임시저장
  });

  // ---------- 임시저장 관련 ---------- //
  const [storageList, setStorageList] = useState([]);
  const [storageListCount, setStorageListCount] = useState(0);

  const getStorageList = async () => {
    try {
      const data = {
        page: 1,
        size: 0,
        saveStatus: "N",
      };
      const response = await ProductApi.getListProduct(data);
      setStorageList(response.data.data.content);
      setStorageListCount(response.data.data.totalCount);
    } catch (error) {
      errorHandler(error);
    }
  };

  // 임시저장 데이터 삭제 관련
  const [deleteStorageItemModalOpen, setDeleteStorageItemModalOpen] =
    useState(false);
  const [deleteStorageItemId, setDeleteStorageItemId] = useState(0);

  const handleDeleteStorageItem = async () => {
    try {
      await ProductApi.deleteProduct(deleteStorageItemId);
      toast(toastMsg.delete);
      setDeleteStorageItemModalOpen(false);
      getStorageList();
    } catch (error) {
      errorHandler(error);
    }
  };

  // 데이터 불러오기
  const handleLoadStorageItem = async (id) => {
    try {
      const response = (await ProductApi.getByIdProduct(id)).data.data.content;

      setProductManagementValue({
        ...response,
        merchMainCategoryId: response?.merchMainCategory?.id || 0,
        merchSubCategoryId: response?.merchSubCategory?.id || 0,
        title: response.title || "",
        writer: response.writer || "",
        price: response.price || 0,
        isPreviewEnabled: response.isPreviewEnabled || false,
        isFreeTrial: response.isFreeTrial || false,
        isComingSoon: response.isComingSoon || false,
        isMembershipOnly: response.isMembershipOnly || false,
        intro: response.intro || "",
        content: response.content || "",
        thumbnailOriginFileName: response.thumbnailOriginFileName || "",
        thumbnailServerFileName: response.thumbnailServerFileName || "",
        bannerOriginFileName: response.bannerOriginFileName || "",
        bannerServerFileName: response.bannerServerFileName || "",
        relatedMerchUse: response.relatedMerchUse || false,
        openAlarmUse: response.openAlarmUse || false,
        merchType: response.merchType || "SHOP",
        merchContentType: response.merchContentType || "BOOK",
      });
      setProductIsUpload(false);
      setPopupOpen((prevPopup) => ({
        ...prevPopup,
        temporary: false,
      }));

      navigate(route.shopping_product_create_basic);
      toast("임시저장 데이터를 불러왔습니다.");
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  // ---------- 다음 단계로 이동 ---------- //
  // 기존 이미지가 있는 경우
  const handleNextStep = async () => {
    if (!imageObj.thumbnailFileName) {
      toast("썸네일 이미지를 등록해주세요.");
      return;
    } else if (!imageObj.bannerFileName) {
      toast("배너 이미지를 등록해주세요.");
      return;
    }

    try {
      if (imageObj.thumbnailFile && imageObj.bannerFile) {
        const thumbnailResponse = await FileApi.fileUpload(
          imageObj.thumbnailFile,
          "admin/product"
        );
        const bannerResponse = await FileApi.fileUpload(
          imageObj.bannerFile,
          "admin/product"
        );
        const data = {
          ...productManagementValue,
          thumbnailOriginFileName: imageObj.thumbnailFile.name,
          thumbnailServerFileName: thumbnailResponse.data.data.serverFileName,
          bannerOriginFileName: imageObj.bannerFile.name,
          bannerServerFileName: bannerResponse.data.data.serverFileName,
        };
        setProductManagementValue(data);
        await ProductApi.updateProduct(productManagementValue.id, data);
      } else if (imageObj.thumbnailFile && !imageObj.bannerFile) {
        const thumbnailResponse = await FileApi.fileUpload(
          imageObj.thumbnailFile,
          "admin/product"
        );
        const data = {
          ...productManagementValue,
          thumbnailOriginFileName: imageObj.thumbnailFile.name,
          thumbnailServerFileName: thumbnailResponse.data.data.serverFileName,
        };
        setProductManagementValue(data);
        await ProductApi.updateProduct(productManagementValue.id, data);
      } else if (!imageObj.thumbnailFile && imageObj.bannerFile) {
        const bannerResponse = await FileApi.fileUpload(
          imageObj.bannerFile,
          "admin/product"
        );
        const data = {
          ...productManagementValue,
          bannerOriginFileName: imageObj.bannerFile.name,
          bannerServerFileName: bannerResponse.data.data.serverFileName,
        };
        setProductManagementValue(data);
        await ProductApi.updateProduct(productManagementValue.id, data);
      }
      navigate(route.shopping_product_create_etc);
      scrollToTop();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <>
      <Header />
      <MainLayout
        style={{
          position: "relative",
          gap: 306,
        }}
      >
        <Sidebar />

        {/* 카테고리 영역 */}
        <SubSideBar title="상품 추가">
          {pageTitleList.map((item, index) => {
            return (
              <React.Fragment key={index}>
                <SubSideBarItem
                  style={{
                    cursor: "default",
                  }}
                  selected={item === pageTitleList[3]}
                >
                  {item}
                </SubSideBarItem>
              </React.Fragment>
            );
          })}
        </SubSideBar>

        {/* 본문 영역 */}
        <DetailPageLayout>
          <TableTitle>{pageTitleList[3]}</TableTitle>

          {/* 썸네일 등록 영역 */}
          <PretendardText
            style={{
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "22.75px",
              color: "#aaa",
              marginBottom: "12px",
            }}
          >
            썸네일 등록
          </PretendardText>
          {productManagementValue.thumbnailServerFileName && (
            <ImgPreviewLarge
              fileUrl={`${fileUrl}/${productManagementValue.thumbnailServerFileName}`}
              onClick={() => {
                setProductManagementValue({
                  ...productManagementValue,
                  thumbnailOriginFileName: "",
                  thumbnailServerFileName: "",
                });
                setImageObj({
                  ...imageObj,
                  thumbnailFile: null,
                  thumbnailFileUrl: null,
                  thumbnailFileName: null,
                });
              }}
            />
          )}
          {!productManagementValue.thumbnailServerFileName &&
            imageObj.thumbnailFileUrl && (
              <ImgPreviewLarge
                fileUrl={imageObj.thumbnailFileUrl}
                onClick={() => {
                  deleteFile("thumbnail");
                }}
              />
            )}
          {!productManagementValue.thumbnailServerFileName &&
            !imageObj.thumbnailFileUrl && (
              <ImgInputLarge
                id={"thumbnailFile"}
                accept={"image/*"}
                onChange={(e) => {
                  inputFile(e, "thumbnail");
                }}
              />
            )}
          <div
            style={{
              width: "100%",
              marginTop: 12,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "rgba(181, 181, 181, 0.5)",
              }}
            >
              최적 size
            </PretendardText>
            <ul
              style={{
                listStyle: "disc",
                listStylePosition: "inside",
                listColor: "rgba(181, 181, 181, 0.5)",
              }}
            >
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "22.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                전자책: 172*243
              </li>
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "22.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                강의/코칭·특강·자문/네트워킹 : 270*170
              </li>
            </ul>
          </div>

          <span
            style={{
              margin: "30px 0px",
              display: "block",
              height: 1,
              width: "100%",
              borderBottom: "0.5px solid rgba(255, 255, 255, 0.12)",
            }}
          />

          {/* 상세페이지 상단 배너 등록 영역 */}
          <PretendardText
            style={{
              fontSize: "14px",
              fontWeight: "600",
              lineHeight: "22.75px",
              color: "#aaa",
              marginBottom: "12px",
            }}
          >
            상세페이지 상단 배너 등록
          </PretendardText>
          {productManagementValue.bannerServerFileName && (
            <ImgPreviewLarge
              fileUrl={`${fileUrl}/${productManagementValue.bannerServerFileName}`}
              onClick={() => {
                setProductManagementValue({
                  ...productManagementValue,
                  bannerOriginFileName: "",
                  bannerServerFileName: "",
                });
                setImageObj({
                  ...imageObj,
                  bannerFile: null,
                  bannerFileUrl: null,
                  bannerFileName: null,
                });
              }}
            />
          )}
          {!productManagementValue.bannerServerFileName &&
            imageObj.bannerFileUrl && (
              <ImgPreviewLarge
                fileUrl={imageObj.bannerFileUrl}
                onClick={() => {
                  deleteFile("banner");
                }}
              />
            )}
          {!productManagementValue.bannerServerFileName &&
            !imageObj.bannerFileUrl && (
              <ImgInputLarge
                id={"bannerFile"}
                accept={"image/*"}
                onChange={(e) => {
                  inputFile(e, "banner");
                }}
              />
            )}
          <div
            style={{
              width: "100%",
              marginTop: 12,
            }}
          >
            <PretendardText
              style={{
                fontSize: "14px",
                fontWeight: "600",
                lineHeight: "22.75px",
                color: "rgba(181, 181, 181, 0.5)",
              }}
            >
              최적 size
            </PretendardText>
            <ul
              style={{
                listStyle: "disc",
                listStylePosition: "inside",
                listColor: "rgba(181, 181, 181, 0.5)",
              }}
            >
              <li
                style={{
                  fontFamily: "Pretendard",
                  fontSize: "14px",
                  fontWeight: "600",
                  lineHeight: "22.75px",
                  color: "rgba(181, 181, 181, 0.5)",
                }}
              >
                760*410
              </li>
            </ul>
          </div>

          <div
            style={{
              width: "100%",
              height: 79,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-end",
              gap: 12,
            }}
          >
            <BasicBtn
              isTransparent={true}
              onClick={() => {
                navigate(route.shopping_product_create_chapter);
                scrollToTop();
              }}
            >
              이전으로
            </BasicBtn>
            {/* <BasicBtn isBlue={true} onClick={() => {}}>
              미리보기
            </BasicBtn> */}
            <DividedBtn
              onClick={() => {
                setPopupOpen((prevPopup) => ({
                  ...prevPopup,
                  temporary: true,
                }));
              }}
              text1="임시저장"
              text2={storageListCount}
              textHandler={() => {
                setPopupOpen((prevPopup) => ({
                  ...prevPopup,
                  temporary: true,
                }));
              }}
            />
            <BasicBtn
              onClick={() => {
                handleNextStep();
              }}
            >
              다음으로
            </BasicBtn>
          </div>
        </DetailPageLayout>
      </MainLayout>

      {/* 임시저장 팝업 */}
      {popupOpen.temporary && (
        <PopupOverLay
          isOpen={true}
          onClick={() => {
            setPopupOpen((prevPopup) => ({
              ...prevPopup,
              temporary: false,
            }));
          }}
        >
          <Popup
            headerTitle="임시저장 글"
            noFooter={true}
            onClick={() => {
              setPopupOpen((prevPopup) => ({
                ...prevPopup,
                temporary: false,
              }));
            }}
          >
            <div
              className="custom-scrollbar"
              style={{
                width: "100%",
                maxHeight: 284,
                overflowY: "auto",
                display: "flex",
                flexDirection: "column",
                marginTop: 16,
                padding: "0px 30px",
              }}
            >
              {storageList.map((item, index) => {
                return (
                  <div
                    key={index}
                    style={{
                      width: "100%",
                      height: 71,
                      padding: "15px 0px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom:
                        "0.5px solid var(--outline1, rgba(255, 255, 255, 0.12))",
                    }}
                  >
                    <div
                      style={{
                        width: 515,
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleLoadStorageItem(item.id);
                      }}
                    >
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 14,
                          lineHeight: "22px",
                          letterSpacing: "-0.3%",
                          color: "#aaa",
                        }}
                      >
                        {item.title}
                      </PretendardText>
                      <PretendardText
                        className="truncate"
                        style={{
                          width: "100%",
                          fontWeight: 500,
                          fontSize: 13,
                          lineHeight: "18.75px",
                          color: "rgba(181, 181, 181, 0.5)",
                        }}
                      >
                        {moment(item.updatedAt).format("YYYY-MM-DD HH:mm")}
                      </PretendardText>
                    </div>
                    <RedBtn
                      onClick={() => {
                        setDeleteStorageItemId(item.id);
                        setDeleteStorageItemModalOpen(true);
                      }}
                    >
                      삭제
                    </RedBtn>
                  </div>
                );
              })}
            </div>
          </Popup>
        </PopupOverLay>
      )}

      {/* 임시저장 삭제하기 모달 */}
      {deleteStorageItemModalOpen && (
        <Modal
          type="negative"
          title="삭제하시겠습니까?"
          text={
            <>
              삭제된 데이터는 복구가 불가합니다.
              <br />
              그래도 삭제하시겠습니까?
            </>
          }
          setModalOpen={setDeleteStorageItemModalOpen}
          onClick={handleDeleteStorageItem}
        />
      )}
    </>
  );
};

export default ShoppingProductCreateImage;
